import PressGridComponent from "./press-grid-component";
import PressGridConfig from "./press-grid-config";
import PressGridAdvancedConfig from "./press-grid-advanced-config";

export default {
  PressGridComponent,
  PressGridConfig,
  PressGridAdvancedConfig
};
